exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Controls__prev___2T3oZ, .Controls__next___9uI0d {\n  background: rgba(255, 255, 255, .10);\n  border-radius: 24px;\n  display: inline-block;\n  cursor: pointer;\n  fill: white;\n  height: 48px;\n  stroke: white;\n  stroke-width: 0;\n  width: 48px;\n  position: absolute;\n  z-index: 2;\n  top: 50%;\n  margin-top: -24px;\n}\n\n.Controls__prev___2T3oZ:hover, .Controls__next___9uI0d:hover {\n  background: rgba(255, 255, 255, .40);\n}\n\n.Controls__prev___2T3oZ {\n  left: 24px;\n}\n\n.Controls__next___9uI0d {\n  right: 24px;\n}\n", ""]);

// exports
exports.locals = {
	"prev": "Controls__prev___2T3oZ",
	"next": "Controls__next___9uI0d"
};